import styles from "./index.module.css";
import React, { useEffect, useState } from "react"
import dayjs from "dayjs";
import Flatpickr from "react-flatpickr";
import WordImporter from "./Unit/WordImporter";
export default function SEO() {
    const emptyLanguage = () => ({ title: '', news_title: '', description: '', content: [] });
    // Multi-language content structure
    const [newsData, setNewsData] = useState({
        en: { title: '', news_title: '', description: '', content: [] },
        ja: { title: '', news_title: '', description: '', content: [] },
        ko: { title: '', news_title: '', description: '', content: [] },
        vi: { title: '', news_title: '', description: '', content: [] }
    });
    // Active language for editing
    const [activeLanguage, setActiveLanguage] = useState('vi');
    
    // Shared data (entered once)
    const [isLoading, setIsLoading] = useState(false);
    const [type, setType] = useState('website')
    const [isHn, setIsHn] = useState(true);
    const [isHcm, setIsHcm] = useState(false);
    const [isDn, setIsDn] = useState(false);
    const [isHp, setIsHp] = useState(false);
    const [isAllBranch, setIsAllBranch] = useState(false);
    const [sortType, setSortType] = useState();
    const [selectedDate, setSelectedDate] = useState('01-01-2026')
    const [thumbnail, setThumbnail] = useState('')
    const [adsImage, setAdsImage] = useState('')
    const [thumbnailAlt, setThumbnailAlt] = useState('')
    const [adsImageAlt, setAdsImageAlt] = useState('')
        const [newsId, setNewsId] = useState('');
        const [publishedNews, setPublishedNews] = useState([]);
        useEffect(() => {
            fetch('/api/content/news/website')
                .then((response) => response.json())
                .then((response) => setPublishedNews(response.data || []))
                .catch((error) => console.error('Unable to load published news:', error));
        }, []);

        const resetForm = () => {
            setNewsId('');
            setNewsData({ en: emptyLanguage(), ja: emptyLanguage(), ko: emptyLanguage(), vi: emptyLanguage() });
            setThumbnail(''); setThumbnailAlt(''); setAdsImage(''); setAdsImageAlt('');
            setSelectedDate('01-01-2026');
            setIsHn(true); setIsHcm(false); setIsDn(false); setIsHp(false); setIsAllBranch(false);
        };

        const editPublishedNews = async (selectedNewsId) => {
            if (!selectedNewsId) return;
            const response = await fetch('/api/content/news/website');
            const result = await response.json();
            const selected = (result.data || []).find((item) => item.newsId === selectedNewsId);
            if (!selected) return;
            setNewsId(selectedNewsId);
            setNewsData((previous) => Object.fromEntries(
                ['en', 'ja', 'ko', 'vi'].map((language) => {
                    const languageNews = selected.languages?.[language];
                    return [language, languageNews ? {
                        title: languageNews.title || '', news_title: languageNews.news_title || '',
                        description: languageNews.metaDescription || '', content: languageNews.content || []
                    } : previous[language]];
                })
            ));
            setThumbnail(selected.thumbnail || ''); setThumbnailAlt(selected.thumbnailAlt || '');
            setAdsImage(selected.adsImage || ''); setAdsImageAlt(selected.adsImageAlt || '');
            setType('website'); setSortType(selected.sortType || 'azumaya'); setSelectedDate(selected.date || '');
            setIsHn(Boolean(selected.hn)); setIsHcm(Boolean(selected.hcm)); setIsDn(Boolean(selected.dn)); setIsHp(Boolean(selected.hp)); setIsAllBranch(Boolean(selected.allBranch));
            setActiveLanguage('vi');
        };
    
    // Helper to get current language data
    const currentLanguageData = newsData[activeLanguage];
    const languages = [
        { code: 'vi', name: 'Vietnamese' },
        { code: 'en', name: 'English' },
        { code: 'ja', name: 'Japanese' },
        { code: 'ko', name: 'Korean' }
    ];
    const sourceCollected = {
        en: {value: "(Source: Collected)"},
        ja: {value: " (出典：編集部調べ）"},
        ko: {value: "(출처: 편집부 조사)"},
        vi: {value: "(Nguồn: Sưu tầm)"}
    }
       const sourceAz = {
        en: {value: "(Source: Azumaya Hotel)"},
        ja: {value: "（出典：東屋ホテル）"},
        ko: {value: "(출처: 아즈마야 호텔)"},
        vi: {value: "(Nguồn: Khách sạn Azumaya)"}
    }
    const controlStyle = {
        width: '100%',
        padding: '12px 14px',
        border: '1px solid #d0d7de',
        borderRadius: 10,
        fontSize: 14,
        backgroundColor: '#fff',
        boxSizing: 'border-box',
        transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
    };

    const textareaStyle = {
        ...controlStyle,
        minHeight: 90,
        resize: 'vertical'
    };

    const blockCardStyle = {
        border: '1px solid #e5e7eb',
        borderRadius: 16,
        padding: 16,
        background: 'linear-gradient(135deg, #f8fbff 0%, #ffffff 100%)',
        boxShadow: '0 4px 14px rgba(0, 0, 0, 0.05)',
        marginBottom: 16
    };

    const actionButtonStyle = {
        padding: '10px 14px',
        borderRadius: 10,
        border: 'none',
        cursor: 'pointer',
        fontWeight: 600,
        transition: 'transform 0.15s ease, box-shadow 0.15s ease'
    };
    
    
    // Prepare data for batch upload - all 4 languages at once
    const prepareBatchData = () => {
        const sharedData = {
            type,
            sortType,
            thumbnail,
            thumbnailAlt,
            adsImage,
            adsImageAlt,
            date: selectedDate,
            hn: isHn,
            hcm: isHcm,
            dn: isDn,
            hp: isHp,
            allBranch: isAllBranch
        }
        
        return {
            ...sharedData,
            newsId,
            languages: newsData
        }
    }

    const postNews = async (data) => {
          setIsLoading(true)
          console.log("Data being sent:", data);
          try {
                        const response = await fetch(newsId ? '/api/content/news' : `/api/content/cab77098-ce3b-4f38-a44d-5081ce702d8b`, {
                        method: newsId ? 'PUT' : 'POST',
            headers: {
              'Content-Type': 'application/json', 
            },
            body: JSON.stringify(data)
            
            });
            
            if (!response.ok) {
            console.log('Response status:', response);
            }
            const responseData = await response.json();
            alert(responseData.msg)
            if (response.ok) {
                const listResponse = await fetch('/api/content/news/website');
                const listData = await listResponse.json();
                setPublishedNews(listData.data || []);
                resetForm();
            }
          } 
          catch (error) {
            console.error('Error:', error);
          }
          finally {
            setIsLoading(false);
          }
      }
      
    const removeBlock = (id) => {
        if (!window.confirm("Delete this block?")) return;
        setNewsData(prev => ({
            ...prev,
            [activeLanguage]: {
                ...prev[activeLanguage],
                content: prev[activeLanguage].content.filter(item => item.id !== id)
            }
        }));
    };
    
    // Update current language data
    const updateCurrentLanguage = (field, value) => {
        setNewsData(prev => ({
            ...prev,
            [activeLanguage]: {
                ...prev[activeLanguage],
                [field]: value
            }
        }));
    };
    
    // Update content block
    const updateContentBlock = (index, field, value) => {
        setNewsData(prev => {
            const updatedContent = [...prev[activeLanguage].content];
            updatedContent[index] = { ...updatedContent[index], [field]: value };
            return {
                ...prev,
                [activeLanguage]: {
                    ...prev[activeLanguage],
                    content: updatedContent
                }
            };
        });
    };
    
    // Update nested field (like saleRoom properties)
    const updateContentBlockNested = (index, nestedField, nestedKey, value) => {
        setNewsData(prev => {
            const updatedContent = [...prev[activeLanguage].content];
            updatedContent[index] = {
                ...updatedContent[index],
                [nestedField]: {
                    ...updatedContent[index][nestedField],
                    [nestedKey]: value
                }
            };
            return {
                ...prev,
                [activeLanguage]: {
                    ...prev[activeLanguage],
                    content: updatedContent
                }
            };
        });
    };
    
    const createEmptyBlock = () => ({
        id: Date.now() + Math.random(),
        type: "paragraph",
        value: "",
        alt:"",
        saleRoom:{
            branch:"",
            name:"",
            name_lang: "",
            image:"",
            alt: "",
            size:"",
            address:"",
            price:""
        }
    });

    const insertBlock = (index) => {
        const newBlock = createEmptyBlock();
        setNewsData(prev => ({
            ...prev,
            [activeLanguage]: {
                ...prev[activeLanguage],
                content: [
                    ...prev[activeLanguage].content.slice(0, index),
                    newBlock,
                    ...prev[activeLanguage].content.slice(index)
                ]
            }
        }));
    };

    // Add new block
    const addBlock = () => {
        const newBlock = createEmptyBlock();
        setNewsData(prev => ({
            ...prev,
            [activeLanguage]: {
                ...prev[activeLanguage],
                content: [...prev[activeLanguage].content, newBlock]
            }
        }));
    };
    
    // Copy from one language to another
    const copyLanguage = (fromLang) => {
        if (!window.confirm(`Copy all content from ${fromLang.toUpperCase()} to ${activeLanguage.toUpperCase()}?`)) return;
        setNewsData(prev => ({
            ...prev,
            [activeLanguage]: { ...prev[fromLang] }
        }));
    };
    
    // Copy image from another language's block
    const copyImageFromLanguage = (fromLang, blockId, blockType) => {
        const fromContent = newsData[fromLang].content;
        const blockFromLang = fromContent.find(b => b.id === blockId);
        
        if (!blockFromLang) {
            alert(`Block not found in ${fromLang.toUpperCase()}`);
            return;
        }
        
        let imageUrl = '';
        if (blockType === 'image') {
            imageUrl = blockFromLang.value;
        } else if (blockType === 'saleRoom') {
            imageUrl = blockFromLang.saleRoom?.image;
        }
        
        if (!imageUrl) {
            alert(`No image found in ${fromLang.toUpperCase()}`);
            return;
        }
        
        // Find current block and update image
        const blockIndex = currentLanguageData.content.findIndex(b => b.id === blockId);
        if (blockIndex !== -1) {
            if (blockType === 'image') {
                updateContentBlock(blockIndex, 'value', imageUrl);
            } else if (blockType === 'saleRoom') {
                updateContentBlockNested(blockIndex, 'saleRoom', 'image', imageUrl);
            }
            alert(`✅ Copied image from ${fromLang.toUpperCase()}`);
        }
    };

    const toSlug = (text) => {
        return text
            .replace(/[^\w\s&-]/g, '')
            .replace(/\s*&\s*/g, '-')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .trim();
    };
    
    // Auto-generate link title when page title changes
    // useEffect(() => {
    //     if (currentLanguageData.news_title) {
    //         updateCurrentLanguage('title', toSlug(currentLanguageData.news_title));
    //     }
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [currentLanguageData.news_title, activeLanguage])
  return (
      <div className="container">
        <div className="d-flex align-items-center" style={{marginTop: 50}}>
            <img src="https://cdn-icons-png.flaticon.com/512/3607/3607459.png" alt="Google Ads" style={{width: 60, height: 60, marginLeft: 30}}/>
        <div style={{fontSize: 60, fontWeight: 'bold', textAlign: 'left', marginLeft: 10}}>SEO</div>
        </div>
          <div style={{fontSize: 50, fontWeight: 'bold', textAlign: 'left', marginLeft: 30}}>News Upload (All Languages)</div>
          <div style={{marginLeft: 30, marginTop: 20, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap'}}>
              <select value={newsId} onChange={(e) => editPublishedNews(e.target.value)} style={{...controlStyle, maxWidth: 500}}>
                  <option value="">Select published news to edit</option>
                  {publishedNews.map((news) => (
                      <option key={news.newsId} value={news.newsId}>{news.news_title || news.title || news.newsId}</option>
                  ))}
              </select>
              {newsId && <button type="button" onClick={resetForm} style={{...actionButtonStyle, backgroundColor: '#e5e7eb'}}>New news</button>}
          </div>
          <WordImporter
                activeLanguage={activeLanguage}
                setNewsData={setNewsData}
            />
          {/* ===== LANGUAGE TABS ===== */}
          <div style={{marginLeft: 30, marginTop: 30, display: 'flex', gap: 10, borderBottom: '2px solid #ddd', paddingBottom: 10}}>
              {languages.map(lang => (
                  <button
                      key={lang.code}
                      onClick={() => setActiveLanguage(lang.code)}
                      style={{
                          padding: '10px 20px',
                          fontSize: 16,
                          fontWeight: activeLanguage === lang.code ? 'bold' : 'normal',
                          backgroundColor: activeLanguage === lang.code ? '#007bff' : '#f0f0f0',
                          color: activeLanguage === lang.code ? 'white' : 'black',
                          border: 'none',
                          borderRadius: '5px 5px 0 0',
                          cursor: 'pointer',
                          transition: 'all 0.3s'
                      }}
                  >
                      {lang.name}
                  </button>
              ))}
          </div>
          
          {/* Copy Language Feature */}
          <div style={{marginLeft: 30, marginTop: 15}}>
              <label style={{marginRight: 10}}>Copy from:</label>
              {languages.filter(l => l.code !== activeLanguage).map(lang => (
                  <button 
                      key={lang.code}
                      onClick={() => copyLanguage(lang.code)}
                      style={{
                          marginRight: 10,
                          padding: '5px 15px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          borderRadius: '3px',
                          cursor: 'pointer'
                      }}
                  >
                      Copy {lang.name}
                  </button>
              ))}
          </div>
          
          {/* ===== SHARED SETTINGS (Top section) ===== */}
          <div style={{marginLeft: 30, marginTop: 30}}>
              <div style={{fontSize: 20, fontWeight: 'bold', marginBottom: 20}}>📋 Shared Settings (Entered Once)</div>
              
              <div className="d-flex" style={{marginBottom: 20, flexWrap: 'wrap'}}>
                  <select 
                      className={styles.contentBookingBranchSelect} 
                      value={type} 
                      onChange={(e) => setType(e.target.value)}
                      style={{padding: 10, marginRight: 10}}
                  >
                      <option value='website'>Vietnam (Web)</option>
                      <option value='website-cam'>Cambodia (Web)</option>
                      <option value='main'>App</option>
                  </select>
                  
                  <select 
                      className={styles.contentBookingBranchSelect} 
                      value={sortType} 
                      onChange={(e) => setSortType(e.target.value)}
                      style={{padding: 10, marginRight: 10}}
                  >
                      <option value='azumaya'>Azumaya Hotel</option>
                      <option value='travel'>Travel</option>
                      <option value='business'>Business</option>
                      <option value='hanoi'>Ha Noi</option>
                      <option value='haiphong'>Hai Phong</option>
                      <option value='danang'>Da Nang</option>
                      <option value='hochiminh'>Ho Chi Minh</option>
                  </select>
                  
                  <Flatpickr 
                      value={selectedDate}
                      options={{dateFormat:'Y-m-d'}} 
                      className={`${styles.contentBookingDate} ${styles.webkitAppearance} mt-0`}
                      placeholder="Select date"
                      onChange={(dates) => setSelectedDate(dayjs(dates[0]).format("YYYY-MM-DD"))}
                      style={{padding: 10, marginRight: 10}}
                  />
              </div>
          </div>
          
        {/* ===== LANGUAGE-SPECIFIC CONTENT ===== */}
        <div style={{marginLeft: 30, marginTop: 30}}>
            <div style={{fontSize: 20, fontWeight: 'bold', marginBottom: 20}}>✍️ {activeLanguage.toUpperCase()} Content</div>
            
            <div className="row mt-3">
                <div className="col-md-3">
                    <label style={{ padding: 20 }}>News Title</label>
                </div>
                <div className="col-md-9">
                    <input
                      type="text"
                      style={{width: '100%', padding: 20 }}
                      placeholder="Enter page title"
                      value={currentLanguageData.news_title}
                      onChange={(e) => updateCurrentLanguage('news_title', e.target.value)}
                    />
                </div>
            </div>
            
            <div className="row">
                <div className="col-md-3">
                    <label style={{ padding: 20 }}>Title</label>
                </div>
                <div className="col-md-9">
                    <input
                      type="text"
                      style={{width: '100%', padding: 20 }}
                      placeholder="Auto-generated from page title"
                      value={currentLanguageData.title}
                      onChange={(e) => updateCurrentLanguage('title', e.target.value)}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-3">
                </div>
                 <div className="col-md-9">
                     <button style={{ ...controlStyle, marginBottom: 10 }} onClick={() => updateCurrentLanguage('title', toSlug(currentLanguageData.news_title))}>Update Title</button>

                 </div>
                </div>
            <div className="row">
              <div className="col-md-3">
                <label style={{ padding: 20 }}>SEO Description</label>
              </div>
              <div className="col-md-9">
                <textarea
                  style={{ padding: 20, minHeight: 100 }}
                  placeholder="Enter meta description"
                  value={currentLanguageData.description}
                  onChange={(e) => updateCurrentLanguage('description', e.target.value)}
                />
              </div>
            </div>
            
            {/* Content Blocks */}
            <div className="row mt-5">
                <div style={{fontSize: 18, fontWeight: 'bold', marginBottom: 20, marginLeft: 20}}>Content Blocks</div>
                {currentLanguageData.content.map((block, index) => (
                    <React.Fragment key={block.id}>
                    <div className="col-12" style={blockCardStyle}>
                        <div className="row g-3 align-items-start">
                            <div className="col-md-3">
                                <select
                                style={{
                                    ...controlStyle,
                                    padding: 14
                                }}
                                value={block.type}
                                onChange={(e) => updateContentBlock(index, 'type', e.target.value)}
                                >
                        <option value="heading">Heading</option>
                        <option value="heading2">Heading 2</option>
                        <option value="paragraph">Paragraph</option>
                        <option value="list">List</option>
                        <option value="image">Image</option>
                        <option value="image-desc">Image Description</option>
                        <option value="internal-link">Internal Link</option>
                        <option value="saleRoom">Sale Room</option>
                        </select>
                    </div>

                    <div className="col-md-7">
                        {block.type === "saleRoom" ? (
                            <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
                                <input
                                    style={controlStyle}
                                    placeholder="Branch"
                                    value={block.saleRoom?.branch || ""}
                                    onChange={(e) => updateContentBlockNested(index, 'saleRoom', 'branch', e.target.value)}
                                />
                                <input
                                    style={controlStyle}
                                    placeholder="Room Name"
                                    value={block.saleRoom?.name || ""}
                                    onChange={(e) => updateContentBlockNested(index, 'saleRoom', 'name', e.target.value)}
                                />
                                <input
                                    style={controlStyle}
                                    placeholder="Room Name Lang"
                                    value={block.saleRoom?.name_lang || ""}
                                    onChange={(e) => updateContentBlockNested(index, 'saleRoom', 'name_lang', e.target.value)}
                                />
                                <input
                                    style={controlStyle}
                                    placeholder="Image"
                                    value={block.saleRoom?.image || ""}
                                    onChange={(e) => updateContentBlockNested(index, 'saleRoom', 'image', e.target.value)}
                                />
                                <div style={{display: 'flex', gap: 8, flexWrap: 'wrap'}}>
                                    {languages.filter(l => l.code !== activeLanguage).map(lang => (
                                        <button
                                            key={lang.code}
                                            onClick={() => copyImageFromLanguage(lang.code, block.id, 'saleRoom')}
                                            style={{
                                                padding: '5px 10px',
                                                fontSize: 12,
                                                backgroundColor: '#17a2b8',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '3px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            📋 {lang.name}
                                        </button>
                                    ))}
                                </div>
                                <input
                                    style={controlStyle}
                                    placeholder="Sale Room Image Alt"
                                    value={block.saleRoom?.alt || ""}
                                    onChange={(e) => updateContentBlockNested(index, 'saleRoom', 'alt', e.target.value)}
                                />
                                <input
                                    style={controlStyle}
                                    placeholder="Size"
                                    value={block.saleRoom?.size || ""}
                                    onChange={(e) => updateContentBlockNested(index, 'saleRoom', 'size', e.target.value)}
                                />
                                <input
                                    style={controlStyle}
                                    placeholder="Address"
                                    value={block.saleRoom?.address || ""}
                                    onChange={(e) => updateContentBlockNested(index, 'saleRoom', 'address', e.target.value)}
                                />
                                <input
                                    style={controlStyle}
                                    placeholder="Price"
                                    value={block.saleRoom?.price || ""}
                                    onChange={(e) => updateContentBlockNested(index, 'saleRoom', 'price', e.target.value)}
                                />
                            </div>
                        ) : (
                            <div>
                                <textarea
                                    style={{
                                        ...textareaStyle,
                                        marginBottom: 10
                                    }}
                                    value={block.value}
                                    onChange={(e) => updateContentBlock(index, 'value', e.target.value)}
                                />
                                {block.type === 'image-desc' && (
                                    <div className="d-flex">
                                         <button
                                          style={{ ...controlStyle, marginBottom: 10 }}
                                    onClick={() =>
                                        updateContentBlock(
                                        index,
                                        "value",
                                        `${block.value} ${sourceCollected[activeLanguage].value}`
                                        )
                                    }
                                    >
                                    Source Collected
                                    </button>
                                     <button
                                      style={{ ...controlStyle, marginBottom: 10 }}
                                    onClick={() =>
                                        updateContentBlock(
                                        index,
                                        "value",
                                        `${block.value} ${sourceAz[activeLanguage].value}`
                                        )
                                    }
                                    >
                                    Source AZ
                                    </button>
                                    </div>
                                )}
                                {block.type === 'image' && (
                                    <>
                                        <input
                                            style={{ ...controlStyle, marginBottom: 10 }}
                                            placeholder="Image Alt"
                                            value={block.alt || ""}
                                            onChange={(e) => updateContentBlock(index, 'alt', e.target.value)}
                                        />
                                        <div style={{display: 'flex', gap: 8, flexWrap: 'wrap'}}>
                                            {languages.filter(l => l.code !== activeLanguage).map(lang => (
                                                <button
                                                    key={lang.code}
                                                    onClick={() => copyImageFromLanguage(lang.code, block.id, 'image')}
                                                    style={{
                                                        padding: '5px 10px',
                                                        fontSize: 12,
                                                        backgroundColor: '#17a2b8',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '3px',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    📋 {lang.name}
                                                </button>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                    </div>

                    <div className="col-md-2">
                        <button
                        type="button"
                        style={{
                            ...actionButtonStyle,
                            width: '100%',
                            minHeight: 44,
                            backgroundColor: '#fee2e2',
                            color: '#b91c1c'
                        }}
                        onClick={() => removeBlock(block.id)}
                        >
                        ✕ Remove
                        </button>
                    </div>
                        </div>
                    </div>
                        {index < currentLanguageData.content.length - 1 && (
                            <div className="col-12 d-flex justify-content-center" style={{ padding: '4px 0' }}>
                                <button
                                    type="button"
                                    style={{
                                        ...controlStyle,
                                        padding: '6px 14px',
                                        fontSize: 13,
                                        borderStyle: 'dashed'
                                    }}
                                    onClick={() => insertBlock(index + 1)}
                                >
                                    + Insert Block Here
                                </button>
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>

            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-9 d-flex gap-2">
                    <button
                    type="button"
                    style={{
                        width: "100%",
                        padding: 16,
                        marginBottom: 20,
                        fontSize: 15,
                        fontWeight: 700,
                        background: 'linear-gradient(90deg, #2563eb 0%, #3b82f6 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: 12,
                        boxShadow: '0 6px 16px rgba(37, 99, 235, 0.25)'
                    }}
                    onClick={addBlock}
                    >
                    + Add Block
                    </button>
                </div>
            </div>
        </div>
        
        {/* ===== SHARED MEDIA ===== */}
        <div style={{marginLeft: 30, marginTop: 30}}>
            <div style={{fontSize: 20, fontWeight: 'bold', marginBottom: 20}}>🖼️ Media (Shared for all languages)</div>
            
            <div className="row">
                <div className="col-md-3">
                    <label style={{ padding: 20 }}>Thumbnail URL</label>
                </div>
                <div className="col-md-9">
                    <textarea
                      style={{ padding: 20, minHeight: 80 }}
                      placeholder="Enter image URL"
                      value={thumbnail}
                      onChange={(e) => setThumbnail(e.target.value)}
                    />
                </div>
            </div>
            
            <div className="row">
                <div className="col-md-3">
                    <label style={{ padding: 20 }}>Thumbnail Alt</label>
                </div>
                <div className="col-md-9">
                    <textarea
                      style={{ padding: 20, minHeight: 80 }}
                      placeholder="Enter image alt"
                      value={thumbnailAlt}
                      onChange={(e) => setThumbnailAlt(e.target.value)}
                    />
                </div>
            </div>
            
            <div className="row">
                <div className="col-md-3">
                    <label style={{ padding: 20 }}>Ads Image</label>
                </div>
                <div className="col-md-9">
                    <textarea
                      style={{ padding: 20, minHeight: 80 }}
                      placeholder="Enter image URL"
                      value={adsImage}
                      onChange={(e) => setAdsImage(e.target.value)}
                    />
                </div>
            </div>
            
            <div className="row">
                <div className="col-md-3">
                    <label style={{ padding: 20 }}>Ads Image Alt</label>
                </div>
                <div className="col-md-9">
                    <textarea
                      style={{ padding: 20, minHeight: 80 }}
                      placeholder="Enter image alt"
                      value={adsImageAlt}
                      onChange={(e) => setAdsImageAlt(e.target.value)}
                    />
                </div>
            </div>
        </div>
        
        {/* ===== BRANCHES ===== */}
        <div style={{marginLeft: 30, marginTop: 30, marginBottom: 30}}>
            <div style={{fontSize: 20, fontWeight: 'bold', marginBottom: 20}}>📍 Areas (Shared for all languages)</div>
            
            <div className={styles.branchContainer}>
                <label className={`${styles.branchItem} ${isHn ? styles.active : ""}`}>
                    <input
                        style={{display: 'none'}}
                        type="checkbox"
                        checked={isHn}
                        onChange={() => setIsHn(!isHn)}
                    />
                    <span>HN</span>
                </label>

                <label className={`${styles.branchItem} ${isHcm ? styles.active : ""}`}>
                    <input
                        style={{display: 'none'}}
                        type="checkbox"
                        checked={isHcm}
                        onChange={() => setIsHcm(!isHcm)}
                    />
                    <span>HCM</span>
                </label>

                <label className={`${styles.branchItem} ${isDn ? styles.active : ""}`}>
                    <input
                        style={{display: 'none'}}
                        type="checkbox"
                        checked={isDn}
                        onChange={() => setIsDn(!isDn)}
                    />
                    <span>DN</span>
                </label>

                <label className={`${styles.branchItem} ${isHp ? styles.active : ""}`}>
                    <input
                        style={{display: 'none'}}
                        type="checkbox"
                        checked={isHp}
                        onChange={() => setIsHp(!isHp)}
                    />
                    <span>HP</span>
                </label>

                <label className={`${styles.branchItem} ${isAllBranch ? styles.active : ""}`}>
                    <input
                        style={{display: 'none'}}
                        type="checkbox"
                        checked={isAllBranch}
                        onChange={() => setIsAllBranch(!isAllBranch)}
                    />
                    <span>All Branch</span>
                </label>
            </div>
        </div>
        
        {/* ===== SUBMIT BUTTON ===== */}
        <div style={{ padding: 20, marginLeft: 30 }}>
            <button 
                style={{ 
                    padding: 20,
                    fontSize: 18,
                    fontWeight: 'bold',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    width: '300px'
                }} 
                onClick={() => postNews(prepareBatchData())}
                disabled={isLoading}
            >
              {isLoading ? (newsId ? 'Updating...' : 'Uploading...') : (newsId ? '💾 Update All Languages' : '🚀 Upload All Languages')}
            </button>
        </div>
    </div>
   
  );
}

